<template>
    <div class="app-user-bar" @click="logout">
        <span class="js-user-logout bar-item">
            <span class="icon">
                <icon-base width="18" height="18" viewBox="0 0 18 18"><icon-logout/></icon-base>
            </span>
            <span class="text">Выйти</span>
        </span>
    </div>
</template>

<script>
    import IconBase from "./IconBase";
    import IconLogout from "./icons/IconLogout";

    export default {
        name: 'user-bar',
        components: {IconLogout, IconBase},
        methods: {
            logout() {
                window.location.href = "/logout";
            }
        }
    }
</script>


<style scoped>

</style>
